const messages: Record<string, string> = {
	'loader.loading': 'Načítavam údaje',
	'loader.error': 'Žiaľ, nepodarilo sa spustiť digitálnu obhliadku. Prosím, skúste to znova.',
	'connectionError.title': 'Chyba spojenia.',
	'connectionError.description': 'Chyba spojenia. Prosím, nahrajte fotky znova.',
	'mainError.tryAgain': 'Skúsiť znova',
	'landing.headline.policyCheck': 'Vitajte',
	'landing.paragraph': 'Digitálnu obhliadku vozidla zvládnete v 2 krokoch',
	'landing.stepDescription.fourDiagonalPerspectives': 'Nafotíte fotky vozidla',
	'landing.stepDescription.feedback': 'Ohodnotíte nás',
	'landing.termsAndConditionsLinkDescription':
		'Ťuknutím na ZAČAŤ potvrdzujem, že som sa oboznamil s <tclink>podmienkami o ochrane a spracovaní osobných údajov</tclink>. ',
	'button.start': 'ZAČAŤ',
	'button.close': 'Zatvoriť',
	'landing.aboutPolicyCheck': 'Späť',
	'tutorialModal.headline.first.policyCheck': 'Čo je digitálna obhliadka?',
	'tutorialModal.paragraph.first.policyCheck':
		'Digitálna obhliadka je aplikácia pre zaznamenanie stavu vozidla v 8 jednoduchých krokoch.',
	'chooseLang.headline': 'Zvoľte si jazyk',
	'blockedByDevice.headline': 'Digitálnu obhliadku nie je možné používať na počítači.',
	'blockedByDevice.description':
		'Používate prehliadač pre klasický počítač/notebook. Digitálnu obhliadku je možné používať len na mobile/tablete. Prosím, použite mobil/tablet.',

	'feedback.button.send': 'ODOSLAŤ',
	'feedback.comment.placeholder': 'Pridať komentár',

	'vehicleImages.overviewPhotos': 'Celkový pohľad na vozidlo',
	'vehicleImages.description':
		'Odfoťte vozidlo zo všetkých uhlov. Tabuľka s evidenčným číslom vozidla musí byť na všetkých fotkách jasne viditeľná.',
	'fourDiagonalPerspectives.vehicleFrontLeft.title': 'Predok a ľavá strana vozidla',
	'fourDiagonalPerspectives.vehicleRearLeft.title': 'Zadok a ľavá strana vozidla',
	'fourDiagonalPerspectives.vehicleRearRight.title': 'Zadok a pravá strana vozidla',
	'fourDiagonalPerspectives.vehicleFrontRight.title': 'Predok a pravá strana vozidla',
	'imageRecognitionFeedback2.exemplaryPhoto': 'Príklad fotky',
	'button.next': 'ĎALEJ',

	'imageRecognitionMismatchModal.headline': 'Prosím, skontrolujte, či sú fotky OK',
	'button.continue': 'POKRAČOVAŤ',
	'button.backchangeImage': 'ODFOTIŤ EŠTE RAZ',

	'vehicleImages.leftFrontOverview': 'Predok a ľavá strana vozidla',
	'vehicleImages.leftRearOverview': 'Zadok a ľavá strana vozidla',
	'vehicleImages.rightRearOverview': 'Zadok a pravá strana vozidla',
	'vehicleImages.rightFrontOverview': 'Predok a pravá strana vozidla',
	'button.changeImage': 'ODFOTIŤ EŠTE RAZ',

	'completeVehicleImagesModal.headline': 'Chýbajúce fotky',
	'completeVehicleImagesModal.description': 'Prosím, doplňte ešte tieto fotky:',
	'completeVehicleImagesModal.hasVehicleImageFrontLeft': 'Predok a ľavá strana vozidla',
	'completeVehicleImagesModal.hasVehicleImageRearLeft': 'Zadok a ľavá strana vozidla',
	'completeVehicleImagesModal.hasVehicleImageRearRight': 'Zadok a pravá strana vozidla',
	'completeVehicleImagesModal.hasVehicleImageFrontRight': 'Predok a pravá strana vozidla',
	'button.ok': 'OK',

	'fourDiagonalPerspectives.vehicleFrontLeft.exampleModalTitle':
		'Príklad fotky predku a ľavej strany vozidla',
	'fourDiagonalPerspectives.vehicleRearLeft.exampleModalTitle':
		'Príklad fotky zadku a ľavej strany vozidla',
	'fourDiagonalPerspectives.vehicleRearRight.exampleModalTitle':
		'Príklad fotky zadku a pravej strany vozidla',
	'fourDiagonalPerspectives.vehicleFrontRight.exampleModalTitle':
		'Príklad fotky predku a pravej strany vozidla',
	'fourPerspectivesExampleModal.button.close': 'OK',

	'button.prev': 'Späť',
	'fourAdditionalPictures.title': 'Doplňujúce informácie',
	'fourAdditionalPictures.overallDashboard.title': 'Palubná doska',
	'fourAdditionalPictures.overallDashboard.description': 'Odfoťte celkový pohľad na palubnú dosku.',
	'fourAdditionalPictures.mileage.title': 'Najazdené kilometre',
	'dashboardMileage.dashboard.paragraph':
		'Odfoťte počet najazdených kilometrov. Ak máte digitálny displej, prosím zapnite ho.',
	'dashboardMileage.paragraph.first': 'Zadajte počet najazdených kilometrov.',
	'dashboardMileage.placeholder': 'Počet najazdených kilometrov',
	'fourAdditionalPictures.windshield.title': 'Čelné sklo',
	'fourAdditionalPictures.windshield.description': 'Odfoťte zblízka celé čelné sklo vozidla.',
	'fourAdditionalPictures.vin.title': 'VIN číslo',
	'fourAdditionalPictures.vin.description':
		'Odfoťte VIN číslo vozidla. Nachádza sa na tesnení vodičových dverí alebo v ľavom dolnom rohu čelného skla.',

	'imageRecognitionMistmatchModal.headline': 'Prosím, skontrolujte, či sú fotky OK',
	'completeFourAdditionalPicturesModal.headline': 'Chýbajúce fotky',
	'completeFourAdditionalPicturesModal.description': 'Prosím, doplňte ešte:',
	'completeFourAdditionalPicturesModal.hasOverallDashboardImage': 'Palubná doska',
	'completeFourAdditionalPicturesModal.hasMileageImage': 'Najazdené kilometre',
	'completeFourAdditionalPicturesModal.hasWindshieldImage': 'Čelné sklo',
	'completeFourAdditionalPicturesModal.hasVINImage': 'VIN číslo',
	'completeDashboardMileageModal.hasValidMileage': 'Počet najazdených kilometrov',

	'fourAdditionalPictures.overallDashboard.exampleModalTitle': 'Príklad fotky palubnej dosky',
	'fourAdditionalPictures.dashboard.exampleModalTitle': 'Príklad fotky najazdených kilometrov',
	'fourAdditionalPictures.windshield.exampleModalTitle': 'Príklad fotky čelného skla',
	'fourAdditionalPictures.vin.exampleModalTitle': 'Príklad fotky VIN čísla',
	'fourAdditionalPicturesExampleModal.button.close': 'OK',

	'upload.message': 'Vaše fotky sa odosielajú k nám. Môže to chvíľu trvať.',

	'feedback.headline.policyCheck': 'Ďakujeme, všetky vaše fotky nám boli úspešne doručené.',
	'feedback.rating.policyCheck': 'Ako sa vám páčila digitálna obhliadka vozidla?',
	'feedback.yourOpinion': 'Máte návrhy na zlepšenie? ',

	'thanks.headline.first': 'Ďakujeme za hodnotenie',
	'waitForAudit.thankYou': 'Ďakujeme za hodnotenie',

	'thanks.paragraph.first': ' ',
	'waitForAudit.description.damageFound': ' ',
	'waitForAudit.description.damageNotFound': ' ',

	'button.reverse': 'Kilometre podľa fotky',
	'button.confirm': 'Potvrdiť zadané kilometre',
	'mileageModal.headline':
		'Prosím, skontrolujte, či ste zadali správny počet najazdených kilometrov',
	'mileageModal.paragraph':
		'Počet najazdených kilometrov na fotke nesúhlasí s počtom kilometrov, ktoré ste zadali. Opravte počet najazdených kilometrov, alebo pokračujte ďalej, ak je zadaný údaj správny.',
	'mileageModal.insertedMileagePlaceholder': 'Kilometre, ktoré ste zadali',
	'mileageModal.pictureMileage': 'Počet najazdených kilometrov z fotky',
	'dashboardMileage.input.error': 'Zadajte počet najazdených kilometrov.',
	'mismatchModal.enteredMileage': 'Najazdené kilometre',

	'dashboardMileage.dashboard.title': 'Najazdené kilometre',
	'windshieldImage.headline': 'Čelné sklo',

	'serviceErrorModal.headline': 'Unexpected error occured',
	'serviceErrorModal.close': 'OK',

	'serviceErrorModal.paragraph.first': 'Unexpected error has occured, please reload the page.',
	'serviceErrorModal.paragraph.second': 'If the error is persistent, reach out for support.',
	'serviceErrorModal.paragraph.details':
		'Please share any additional detail (e.g., screenshot) that could help us reproduce the error.',

	'overallDashboardImage.headline': 'Palubná doska',
	'vinPicture.headline': 'VIN číslo',

	'invalidFile.size.title': 'Nesprávna veľkosť fotky',
	'invalidFile.size.description':
		'Veľkosť vašej fotografie je väčšia ako maximálna požadovaná veľkosť.',
	'invalidFile.extension.title': 'Typ súboru nie je podporovaný',
	'invalidFile.extension.description':
		'Fotka môže byť len vo formáte .jpg, .jpeg, .jfif, .heic, .heif, .png and .bmp',
};

export default messages;
